import { Component, OnInit, ViewChild } from '@angular/core';
import { Message, SelectItem } from 'primeng/primeng';
import { PositionService} from '../services/position.service';
import { AddressService } from '../services/address.service';
import { DriverService} from '../services/driver.service';
import { UserService } from '../services/user.service';
import { Table } from 'primeng/components/table/table';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-travel-driver-report',
  templateUrl: './travel-driver-report.component.html',
  styleUrls: ['./travel-driver-report.component.css']
})
export class TravelDriverReportComponent implements OnInit {
  fileName:String;
  filter:String;
  filters: SelectItem[];
  position:any;
  options: any;
  overlays: any[];
  displayLocation: boolean=false;
  drivers: SelectItem[];
  positions : any [];
  dateOptions: SelectItem[];
  dateOption: any;
  idDriver: number;
  disabledInitialDate: boolean;
  disabledFinalDate: boolean;
  initialDate: Date;
  finalDate: Date;
  msgs: Message[] = [];
  blockedDocument: boolean = false;
  cols: any[];
  distanceTotal :number;
  maxDays:number=35;

  @ViewChild('dt') table: Table;

  constructor(private positionService:PositionService, private driverService:DriverService
    ,private addressService:AddressService, private userService:UserService) { }

    ngOnInit() {
      this.cols = [
        { field: 'nameDevice', header: 'NOMBRE' },
        { field: 'nameDriver', header: 'CONDUCTOR' },
        { field: 'from', header: 'DESDE' },
        { field: 'fromAddress', header: 'DIRECCION INICIO' },
        { field: 'to', header: 'HASTA' },
        { field: 'toAddress', header: 'DIRECCION FINAL' },
        { field: 'distanceTraveled', header: 'DISTANCIA (km)' },
        { field: 'duration', header: 'DURACION' },
        { field: 'speedAvg', header: 'VELOCIDAD PROMEDIO (km/hr)' }
      ];
      this.filters = [
        {label: 'Encendido', value: 'ignition'},
        {label: 'Velocidad', value: 'speed'}
      ];
      this.dateOptions = [
        {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
        {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
        {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
        {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
      ];

      this.drivers = [];

      if(this.userService.userLoged.idCompany == null || this.userService.userLoged.idCompany == undefined){
        this.driverService.findAll().then(data => {
          let response: any = data;
          response.drivers.forEach(item => {
            this.drivers.push({label: item.name, value: item.idDriver});
          });
        }).catch(err =>{
          console.log(err);
          this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        });
      }else{
        this.driverService.findByCompany(this.userService.userLoged.idCompany).then(data => {
          let response: any = data;
          response.drivers.forEach(item => {
            this.drivers.push({label: item.name, value: item.idDriver});
          });
        }).catch(err =>{
          console.log(err);
          this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        });
      }
      this.dateOption = '7';
      this.filter='ignition';
      this.changeDate();
    }

    changeDate(){
      this.disabledInitialDate = true;
      this.disabledFinalDate = true;
      if(this.dateOption == 'T'){
        this.initialDate = new Date();
        this.finalDate = new Date();
        this.initialDate.setHours(0,0,0);
        this.finalDate.setHours(23,59,59);
      }else if(this.dateOption == 'Y'){
        this.initialDate = new Date();
        this.finalDate = new Date();
        this.initialDate.setDate(this.initialDate.getDate() - 1);
        this.initialDate.setHours(0,0,0);
        this.finalDate.setDate(this.finalDate.getDate() - 1);
        this.finalDate.setHours(23,59,59);
      }else if(this.dateOption == '7'){
        this.initialDate = new Date();
        this.finalDate = new Date();
        this.initialDate.setDate(this.initialDate.getDate() - 6);
        this.initialDate.setHours(0,0,0);
        this.finalDate.setHours(23,59,59);
      }else{
        this.disabledInitialDate = false;
        this.disabledFinalDate = false;
      }
    }

    diferenciaEntreFechasEnDias(a:Date, b:Date):number{
      return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
    }

    buscar(){
      if(this.table){
        this.table.first=1;
      }

      this.fileName="ReporteViajes_";
      this.drivers.forEach(item =>{
        if(item.value == this.idDriver){
          this.fileName = this.fileName+item.label;
        }
      });
      if(this.diferenciaEntreFechasEnDias(this.initialDate,this.finalDate) > this.maxDays){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"El rango de fechas no debe exceder los "+this.maxDays+" dias"}];
        return;
      }
      if(this.initialDate >= this.finalDate){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"La fecha final debe ser superior a la fecha inicial"}];
        return;
      }

      this.blockedDocument = true;
      this.positions = [];
      this.distanceTotal = 0;
      this.positionService.findDriverTravels(this.initialDate,this.finalDate,this.idDriver,this.filter,this.userService.userLoged.idUser).then(data => {
        let response: any = data;
        if(response.positions == null){
          this.msgs = [{severity:'info', summary:'INFO', detail:"No se encontraron registros"}];
          this.blockedDocument = false;
          return;
        }
        response.positions.forEach(item => {
          if(item.time >= 2*1000*60){
            item.latitude = item.latitude.toFixed(6);
            item.longitude = item.longitude.toFixed(6);
            item.latitudeTo = item.latitudeTo.toFixed(6);
            item.longitudeTo = item.longitudeTo.toFixed(6);
            item.speedMax = item.speedMax.toFixed(2);
            item.speedAvg = (item.speedSum/item.totalRecords).toFixed(2);
            item.distanceTraveled = (item.distanceTraveled/1000).toFixed(2);
            item.latLng = item.latitude+", "+item.longitude
            item.latLngTo = item.latitudeTo+", "+item.longitudeTo
            this.distanceTotal = this.distanceTotal + +item.distanceTraveled;

            let index:number = item.extended.indexOf(item.extended.find(x => x.key == "driverUniqueId"));
            item.nameDriver = item.extended[index].value;

            this.positions.push(item);
          }
        });
        this.distanceTotal = +this.distanceTotal.toFixed(2);
        this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });

    }

    showInMap(position:any){
      this.position = position;
      let latLng = new google.maps.LatLng(position.latitude, position.longitude);
      this.options = {
        zoom: 13,
        center:latLng
      };
      let labelStart = {text: "DESDE",color: 'deepskyblue',fontSize: "12px",fontWeight: "bold"};
      let iconStart = {
        url: "assets/layout/images/markers/blue.png", // url
        scaledSize: new google.maps.Size(45, 45), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(22.5, 38), // anchor,
        labelOrigin: new google.maps.Point(22,-5)
      };
      let labelFinal = {text: "HASTA",color: 'green',fontSize: "12px",fontWeight: "bold"};
      let iconFinal = {
        url: "assets/layout/images/markers/green.png", // url
        scaledSize: new google.maps.Size(45, 45), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(22.5, 38), // anchor,
        labelOrigin: new google.maps.Point(22,-5)
      };

      this.overlays = [];
      this.displayLocation = true;
      this.blockedDocument = true;
      let recorrido = new google.maps.Polyline({
        geodesic: true,
        strokeColor: '#FF0000',
        strokeOpacity: 1.0,
        strokeWeight: 3
      });
      this.overlays.push(recorrido);

      let latLngFinal = null;
      this.positionService.findRange(position.idDevice,position.idPosition,position.idPositionFinal).then(data => {
        let response: any = data;
        response.positions.forEach(item => {
          let latLng = new google.maps.LatLng(item.latitude, item.longitude);
          recorrido.getPath().push(latLng);
          latLngFinal = new google.maps.LatLng(item.latitude, item.longitude);
        });
        let markerStart = new google.maps.Marker({position: latLng, icon: iconStart,label:labelStart});

        this.overlays.push(markerStart);

        let markerFinal = new google.maps.Marker({position: latLngFinal,icon: iconFinal,label:labelFinal});
        this.overlays.push(markerFinal);

        this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });
    }

    getAddressTo(position:any){
      //let latLng = new google.maps.LatLng(position.latitudeTo, position.longitudeTo);
      let request = {latitude:position.latitudeTo,longitude:position.longitudeTo,idDevice:position.idDevice,deviceTime:position.deviceTime}
      this.blockedDocument = true;
      this.addressService.findAddressByCoordinates(request).then(data =>{
        let response: any = data;
          if(response.status == 'OK'){
            position.toAddress = response.address;
            this.msgs = [{severity:'info', summary:'INFO', detail:'Dirección obtenida Exitosamente'}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
          this.blockedDocument = false;
      });;
    }

    getAddressFrom(position:any){
      //let latLng = new google.maps.LatLng(position.latitudeTo, position.longitudeTo);
      let request = {latitude:position.latitude,longitude:position.longitude,idDevice:position.idDevice,deviceTime:position.deviceTime}
      this.blockedDocument = true;
      this.addressService.findAddressByCoordinates(request).then(data =>{
        let response: any = data;
          if(response.status == 'OK'){
            position.fromAddress = response.address;
            this.msgs = [{severity:'info', summary:'INFO', detail:'Dirección obtenida Exitosamente'}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
          this.blockedDocument = false;
      });;
    }

    hide(){
      this.displayLocation = false;
    }

    exportXLS(){
      let records = [];
      this.positions.forEach(item=>{
        let data = {};
        this.cols.forEach(col => {
          data[col.header] = item[col.field];
        });
        records.push(data);
      });

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
      const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
      XLSX.writeFile(workbook, this.fileName+".xlsx");
    }
}



// WEBPACK FOOTER //
// ./src/app/travel-driver-report/travel-driver-report.component.ts